import { Container } from 'react-bootstrap';
import styles from './CourseBox.module.scss';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CourseBoxComponent = ({ course }) => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <Container
      className={`${styles.courseBox} gradient-border`}
      style={{ backgroundImage: `url(${!!course.header ? course.header : null})` }}
      onClick={() => {
        history.push(`/course/${course.id}`);
      }}
    >
      <div className={'d-flex mb-4'}>
        <h2 className={`mb-0 ${styles.cropText2} ${styles.courseTitle}`}>
          {course.name}
        </h2>
        <div className={`d-flex flex-column ml-auto align-items-center ${styles.courseStats}`}>
          {/* TODO: Controllare se esiste il certificato */}
          {course.withCertificate && <div className={styles.certificationChip}>{t('course.labels.withCertificate')}</div>}
          <div className={`mt-auto ${styles.unitsLength}`}>
            <b>{course.chapters.flatMap((chapter) => chapter.units).length}</b> Video
          </div>
        </div>
      </div>
      {!!course.description && (
        <div className={styles.cropText3}>
          {course.description.map((segment, i) => (
            <p className={'m-0'} key={i.toString()}>
              {segment}
            </p>
          ))}
        </div>
      )}
      {!!course.header && <div className={styles.courseImageWrapper}></div>}
    </Container>
  );
};

export { CourseBoxComponent as CourseBox };
